import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import '@/assets/styles/main.scss'
import "quill/dist/quill.core.css";

Vue.use(VueAxios, axios)
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//wow
import animated from 'animate.css'
import 'wowjs/css/libs/animate.css'
Vue.use(animated)



router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
